import type { TextareaHTMLAttributes } from "react";

import { cn } from "../../lib/cn";

type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
	label?: string;
	error?: string;
};

export function Textarea({ label, error, className, id, ...props }: TextareaProps) {
	const textareaId = id ?? (label ? label.toLowerCase().replace(/\s+/g, "-") : undefined);

	return (
		<div className="flex flex-col gap-1.5">
			{label && (
				<label htmlFor={textareaId} className="text-sm font-medium text-pastel-black">
					{label}
				</label>
			)}
			<textarea
				id={textareaId}
				className={cn(
					"w-full rounded-lg border bg-white px-3 py-2 text-sm text-pastel-black placeholder:text-pastel-gray",
					"focus:outline-none focus:ring-2 focus:ring-pastel-vibrant-blue/40 focus:border-pastel-vibrant-blue",
					"transition-colors resize-none",
					error ? "border-red-400" : "border-pastel-border",
					className
				)}
				{...props}
			/>
			{error && <p className="text-xs text-red-500">{error}</p>}
		</div>
	);
}
